"use client";
import React, { useRef, useEffect } from "react";
import { cn } from "utils";
import { ospThemes } from "@ospweb/sdk-ui";
import { createEasyLineChart } from "../../createChart";
import { ChartConfig, PriceChangeStatus } from "./types";

interface ChartSectionProps {
  chart: ChartConfig;
  changeStatus: PriceChangeStatus;
}

// 涨跌颜色映射（与PriceSection保持一致）
const chartColorMapping: Record<PriceChangeStatus, string> = {
  up: ospThemes.colors.content_accent1_primary, // 涨：绿色
  down: ospThemes.colors.content_accent2_primary, // 跌：红色
  flat: ospThemes.colors.content_tertiary, // 平：灰色
};

export const ChartSection: React.FC<ChartSectionProps> = ({
  chart,
  changeStatus,
}) => {
  const chartRef = useRef<HTMLDivElement>(null);

  // 根据涨跌状态获取图表颜色
  const chartColor = chartColorMapping[changeStatus];

  // 初始化图表
  useEffect(() => {
    if (!chartRef.current || !chart?.data?.length) {
      return;
    }

    const chartInstance = createEasyLineChart({
      data: chart.data,
      el: chartRef.current,
      lineColor: chartColor,
      shadow: true,
    });

    return () => {
      chartInstance?.cleanup();
    };
  }, [chart, chartColor]);

  return (
    <div
      className={cn("relative w-[323px] h-[138px] rounded-2 overflow-hidden")}
    >
      <div ref={chartRef} className="w-full h-full" />
    </div>
  );
};
